import { render, staticRenderFns } from "./cityDetails.vue?vue&type=template&id=2506e752&scoped=true&"
import script from "./cityDetails.vue?vue&type=script&lang=js&"
export * from "./cityDetails.vue?vue&type=script&lang=js&"
import style0 from "./cityDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./cityDetails.vue?vue&type=style&index=1&id=2506e752&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2506e752",
  null
  
)

export default component.exports